import { v4 as uuid } from 'uuid';

import { orderSliceActions } from 'app/pages/order/redux/order-slice';
import type { AppDispatch } from 'app/redux/types/types';

import { resetOrderForNewServiceLocationActionCreator } from './reset-order-state-for-new-service-location-action-creator';

export const selectServiceLocationActionCreator = (selectedServiceLocationId: number) => (dispatch: AppDispatch) => {
    dispatch(resetOrderForNewServiceLocationActionCreator());
    dispatch(orderSliceActions.selectServiceLocation(selectedServiceLocationId));
    dispatch(orderSliceActions.setSalesId(uuid()));
};
